import type { MetaAdsTranslations } from '../interfaces/metaAds';

export const metaAdsTranslations: MetaAdsTranslations = {
  page_title: 'Meta Ads',
  page_subtitle:
    'Connect your Meta ad account and track how your campaigns perform.',
  manage_connection: 'Manage connection',

  connect_title: 'Connect Meta Ads',
  connect_body:
    'Log in with Facebook to link an ad account and see campaign data here.',
  connect_button: 'Connect with Facebook',
  sdk_error:
    'The Facebook SDK could not load. Disable your ad blocker for this page and reload.',
  config_missing:
    'The Meta Ads login is not configured for this environment yet.',
  toast_connected: 'Facebook account connected',
  toast_cancelled: 'Login cancelled',
  toast_error: 'Something went wrong. Try again.',

  pick_account_title: 'Choose an ad account',
  pick_account_body:
    'Your Facebook login is connected. Pick the ad account you want to track.',
  reload_accounts: 'Reload accounts',
  available_empty: 'No ad accounts are visible with this Facebook login.',
  account_connect: 'Connect',
  account_connected: 'Connected',
  account_not_covered: 'No access',
  toast_account_connected: 'Ad account connected',

  account_select_label: 'Ad account',
  range_label: 'Date range',
  range_today: 'Today',
  range_7d: 'Last 7 days',
  range_14d: 'Last 14 days',
  range_30d: 'Last 30 days',
  sync_button: 'Sync now',
  toast_sync_started: 'Sync started — data will refresh in a moment',
  refresh_button: 'Refresh',

  summary_spend: 'Spend',
  summary_impressions: 'Impressions',
  summary_clicks: 'Clicks',
  summary_ctr: 'CTR',
  summary_cpc: 'CPC',
  summary_conversations: 'Conversations',
  settling_note:
    'Some recent data is still settling on Meta and may change slightly.',

  campaigns_title: 'Campaigns',
  campaigns_empty_title: 'No campaign data yet',
  campaigns_empty_body:
    'Run a sync to pull campaigns and metrics from Meta for the selected range.',
  table_campaign: 'Campaign',
  table_status: 'Status',
  table_spend: 'Spend',
  table_impressions: 'Impressions',
  table_clicks: 'Clicks',
  table_conversations: 'Conversations',
  table_cost_per_conversation: 'Cost / conv.',
  status_active: 'Active',
  status_paused: 'Paused',
};
